import React from 'react';
import SettingToggle, { SettingToggleList } from '../../atoms/SettingToggle/SettingToggle';

export interface Props {
  handleToggleSettingCookie: (value: boolean) => void;
  handleToggleTrackingCookie: (value: boolean) => void;
  handleToggleMarketingCookie: (value: boolean) => void;
  handleToggleSocialCookie: (value: boolean) => void;
  settingCookie: boolean;
  trackingCookie: boolean;
  marketingCookie: boolean;
  socialCookie: boolean;
  isOverlay?: boolean;
  className?: string;
}
const CookieSettings: React.FC<Props> = ({
  handleToggleSettingCookie,
  handleToggleTrackingCookie,
  handleToggleMarketingCookie,
  handleToggleSocialCookie,
  settingCookie,
  trackingCookie,
  marketingCookie,
  socialCookie,
  className,
}) => {
  return (
    <SettingToggleList className={className}>
      <SettingToggle
        checked={true}
        disabled={true}
        id="cookie-essential"
        title="Essential website cookies"
        description="These cookies are strictly necessary to provide you with services available through our website and to use some of its features, such as access to secure areas."
      />
      <SettingToggle
        checked={settingCookie}
        onCheckedChange={handleToggleSettingCookie}
        id="cookie-settings"
        title="Cookies that remember your settings"
        description="These cookies do things like remember your preferences and the choices you make, to personalise your experience of using the site."
      />
      <SettingToggle
        checked={trackingCookie}
        onCheckedChange={handleToggleTrackingCookie}
        id="cookie-tracking"
        title="Analytics cookies"
        description="These cookies help us understand how our website is being used, how effective marketing campaigns are, and help us customize and improve our websites for you."
      />
      <SettingToggle
        checked={marketingCookie}
        onCheckedChange={handleToggleMarketingCookie}
        id="cookie-marketing"
        title="Advertising cookies"
        description="These cookies are used to make advertising messages more relevant to you. They perform functions like preventing the same ad from continuously reappearing, ensuring that ads are properly displayed for advertisers, selecting advertisements that are based on your interests and measuring the number of ads displayed and their performance, such as how many people clicked on a given ad."
      />
      <SettingToggle
        checked={socialCookie}
        onCheckedChange={handleToggleSocialCookie}
        id="cookie-social"
        title="Social networking cookies"
        description="These cookies are used to enable you to share pages and content that you find interesting on our website through third-party social networking and other websites. These cookies may also be used for advertising purposes too."
      />
    </SettingToggleList>
  );
};

export default CookieSettings;
